import { render, staticRenderFns } from "./partners-tab.component.vue?vue&type=template&id=7875334e&scoped=true"
import script from "./partners-tab.component.vue?vue&type=script&lang=js"
export * from "./partners-tab.component.vue?vue&type=script&lang=js"
import style0 from "./partners-tab.component.vue?vue&type=style&index=0&id=7875334e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875334e",
  null
  
)

export default component.exports